import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamURPK() {
  const html = document.documentElement;

  // 设置 lang 属性
  html.setAttribute('lang', 'ur-PK');

  // 根据语言设置 dir (方向)
  // 常见的 RTL 语言：乌尔都语、阿拉伯语等
  html.setAttribute('dir', 'rtl');
  return (
    <div className={styles["declaration"]}>
      <h1>فیلڈ فورس ممبران کی تربیت اور امتحان کے لیے عملی بیان</h1>

      <p>
        فرنٹ لائن پر تھرڈ پارٹی پروموٹرز کی خدمت کے معیار کو بہتر بنانے کے لیے، شیاؤمی انٹرنیشنل ڈیپارٹمنٹ ٹریننگ ٹیم (جسے ہم یا ہماری کمپنی کہا جاتا ہے) آؤٹ سورسنگ سروس فراہم کنندگان کی طرف سے نامزد کردہ تھرڈ پارٹی پروموٹرز (جسے تربیتی اراکین کہا جاتا ہے) کو تربیتی کورسز اور علم کو مضبوط بنانے والے امتحانات فراہم کرتی ہے۔ تربیت اور امتحان کا مقصد کورس کے مواد کو بہتر بنانا اور سیکھنے کے نتائج کو مستحکم کرنا ہے، اور یہ کسی قسم کے لیبر رشتے یا اصل انتظامی رویے کی تشکیل نہیں کرتا۔ تربیت اور امتحان سے متعلق بیان درج ذیل ہے:
      </p>

      <ol>
        <li>
          <strong>تربیت اور امتحان کی نوعیت</strong><br/>
          تمام تربیتی کورسز اور امتحانات علم کی اشتراک کے مقصد کے لیے کیے جاتے ہیں، تاکہ تربیتی اراکین مصنوعات کی معلومات اور خدمت کے معیارات وغیرہ کو منظم طریقے سے سمجھ سکیں۔ امتحانی نتائج صرف تربیتی مواد پر تربیتی اراکین کی گرفت کو ظاہر کرتے ہیں اور کارکردگی کے جائزے کی بنیاد کے طور پر استعمال نہیں ہو سکتے؛ ہمارا آؤٹ سورسنگ سروس فراہم کنندگان کی طرف سے تربیتی اراکین کے کارکردگی کے جائزوں، تنخواہ کی تقسیم یا دیگر لیبر رشتے کے معاملات میں دخل دینے کا کوئی اختیار نہیں ہے اور نہ ہی ہم دخل دیں گے۔
        </li>
        <li>
          <strong>قانونی رشتے کی وضاحت</strong><br/>
          تربیتی اراکین اور ان کے متعلقہ آؤٹ سورسنگ سروس فراہم کنندگان کے درمیان آجر-ملازم کا رشتہ اس تربیتی اور امتحانی پروگرام سے متاثر نہیں ہوتا۔ ہماری کمپنی اور تربیتی اراکین کے درمیان کوئی آجر-ملازم کا رشتہ نہیں ہے، اور نہ ہی یہ علم کی اشتراکی تربیتی اور امتحانی پروگرام تربیتی اراکین کے ساتھ کوئی حقیقی ملازمت کا رشتہ قائم کرتا ہے۔
        </li>
        <li>
          <strong>امتحانی نتائج کا استعمال</strong><br/>
          امتحانی نتائج صرف مندرجہ ذیل مقاصد کے لیے استعمال کیے جائیں گے:
          <ol type="1">
            <li>ہماری کمپنی کے اندرونی کورس کی بہتری اور اصلاح کے لیے حوالہ کے طور پر؛</li>
            <li>آؤٹ سورسنگ سروس فراہم کنندگان کو تربیتی اراکین کی پیشہ ورانہ قابلیت کے ثبوت کے طور پر فراہم کیے جائیں گے، جو فراہم کنندگان کی آزادانہ رائے اور مرضی کے تابع ہوں گے؛</li>
            <li>امتحانی نتائج کو عوامی یا کسی تیسرے فریق کو ظاہر نہیں کیا جائے گا۔</li>
          </ol>
        </li>
      </ol>

      <p>
        یہ بیان تاریخ اشاعت سے نافذ ہوگا۔ تربیتی اور امتحانی پروگرام میں شرکت تربیتی اراکین کی طرف سے اس بیان کی تسلیم اور قبولیت سمجھی جائے گی۔ ہماری کمپنی اس بیان کی آخری تشریح اور معقول ترمیم کا حق محفوظ رکھتی ہے۔
      </p>

      <div className={styles["footer"]}>
        شیاؤمی انٹرنیشنل ڈیپارٹمنٹ ٹریننگ ٹیم<br/>
        تاریخ: {getLocalizedTime('ur-PK')}
      </div>
    </div>
  );
}